import script from "./avatar.vue?vue&type=script&lang=ts&setup=true"
export * from "./avatar.vue?vue&type=script&lang=ts&setup=true"

import "./avatar.vue?vue&type=style&index=0&id=02316265&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02316265"]])

export default __exports__